import Ticket from "@/assets/icons/Ticket";
import { useTranslation } from "react-i18next";

export function EmptyCupons() {
  const { t } = useTranslation("common");

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
      <div className="mb-4">
        <Ticket />
      </div>
      <h2 className="text-2xl font-semibold text-white mb-2">
        {t("emptyCoupons.title")}
      </h2>
      <p className="text-zinc-400">{t("emptyCoupons.description")}</p>
    </div>
  );
}
